export default __webpack_public_path__ + "static/media/payment.afbc75fd.svg";